import { stateAt } from "./cpFieldRules";

// The plain /operator-sign page's PDF address, built as it always was.
export const legacyOperatorAddress = (details, stateList) =>
  details?.address_line_1 + ", " + details?.city + ", " + stateAt(details?.state, stateList) + " " + details?.zip_code;
